module.exports = require("./kok-IN");